// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"394":"fa0ae9ef","417":"7281b2a3","488":"e9eaf7d6","777":"08932c8e","815":"bfec9d76"}[chunkId] + ".css";
};